import React, { useState, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import SelectTab from '../share/SelectTab';
import Total from './total/total';
import Items from './items/items';

const EanHotelTab = {
  TOTAL: '総数',
  ITEMS: '全件'
} as const;
export type EanHotelTabType = keyof typeof EanHotelTab;

const EanHotel = observer(() => {
  const history = useHistory();
  const [eanHotelTab, setEanHotelTab] = useState<EanHotelTabType>(
    (utils.getParam('ean_hotel_type') as EanHotelTabType) ||
      (utils.getParam('ean_hotel_tab') as EanHotelTabType) ||
      'TOTAL'
  );

  useEffect(() => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
    currentParams.set('sub_tab', 'EAN_HOTEL');
    if (!currentParams.has('ean_hotel_type')) {
      currentParams.set('ean_hotel_type', eanHotelTab);
    }
    history.replace(`/arrangement/todo_list?${currentParams.toString()}`);
  }, [history, eanHotelTab]);

  const handleTabChange = useCallback(
    (tab: EanHotelTabType) => {
      setEanHotelTab(tab);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', 'EAN_HOTEL');
      currentParams.set('ean_hotel_type', tab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history]
  );

  return (
    <>
      <SelectTab tabs={EanHotelTab} currentTab={eanHotelTab} onChange={handleTabChange} />
      {eanHotelTab === 'ITEMS' ? <Items /> : <Total />}
    </>
  );
});

export default EanHotel;
